/*
|--------------------------------------------------------------------------
|
| 用于本地调试组件，配合环境变量 VITE_COMP 参数来决定载入哪个组件调试
|
|--------------------------------------------------------------------------
*/
import { createApp } from 'vue';
import TDesign from 'tdesign-vue-next';
import 'tdesign-vue-next/es/style/index.css';
import libProperties from './entrance/libProperties';
import Empty from './components/empty.vue';

const compName = import.meta.env.VITE_COMP || 'App';

export function loadApp(shouldMount) {
  let targetComp = shouldMount ? libProperties[compName] : Empty;
  if (window.location.search.includes('calc')) {
    console.log('found calc');
    targetComp = libProperties.App;
  }

  const app = createApp(targetComp);
  app.use(TDesign);
  app.mount('#app');
  return app;
}
